/* Brisbane Boxing — Kids pages: sticky call-to-action bar only.
   Progressive enhancement: without JavaScript the bar stays hidden and every
   page remains fully usable (all buttons also appear in the page content).
   Shows the bar once the hero has scrolled away, hides it while the closing
   call to action or the footer is on screen, and lets visitors dismiss it. */
(function () {
  function initSticky(bar) {
    if (bar.dataset.bbkReady) return;
    bar.dataset.bbkReady = 'true';
    if (!('IntersectionObserver' in window)) return; // stay hidden on very old browsers

    var controls = bar.querySelectorAll('a, button');
    var blockers = new Set();
    var pastHero = false;
    var dismissed = false;

    function update() {
      var focused = document.activeElement;
      var pageFocus = focused && !bar.contains(focused) &&
        (focused.matches(':focus-visible, iframe, video, audio'));
      var show = !dismissed && pastHero && blockers.size === 0 && !pageFocus;
      bar.classList.toggle('is-focus-hidden', pageFocus);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      for (var i = 0; i < controls.length; i++) {
        if (show) { controls[i].removeAttribute('tabindex'); } else { controls[i].setAttribute('tabindex', '-1'); }
      }
    }

    // Hide immediately for page keyboard focus, without moving focus or scrolling.
    // This works at any bar height, including wrapped text and browser zoom.
    function refreshFocus() { window.requestAnimationFrame(update); }
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', refreshFocus);
    document.addEventListener('keydown', refreshFocus);
    document.addEventListener('pointerdown', refreshFocus);
    // Embedded widgets and native media controls can manage focus internally.
    window.addEventListener('blur', refreshFocus);
    window.addEventListener('focus', refreshFocus);

    var hero = document.querySelector('[data-bbk-hero]');
    if (hero) {
      new IntersectionObserver(function (entries) {
        pastHero = !entries[0].isIntersecting;
        update();
      }).observe(hero);
    } else {
      pastHero = true;
    }

    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { blockers.add(entry.target); } else { blockers.delete(entry.target); }
      });
      update();
    });
    document.querySelectorAll('[data-bbk-hide-sticky], footer, .footer').forEach(function (el) { watcher.observe(el); });

    var close = bar.querySelector('[data-bbk-close]');
    if (close) {
      close.addEventListener('click', function () {
        dismissed = true;
        update();
      });
    }

    update();
  }

  function init() {
    document.querySelectorAll('[data-bbk-sticky]').forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
